import { DEFAULT_SEE_LESS, DEFAULT_SEE_MORE } from './ExpandableText.constants';
export function getShortenedText(content, charLimit) {
  return content.substr(0, content.lastIndexOf(' ', charLimit)).concat('...');
}
export function contentExceedsCharLimit(content, charLimit) {
  return content && content.length > charLimit;
}
export function getCurrentContent(content, charLimit) {
  return contentExceedsCharLimit(content, charLimit) ? getShortenedText(content, charLimit) : content;
}
export function getButtonText(content, currentContent) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref$seeMoreText = _ref.seeMoreText,
    seeMoreText = _ref$seeMoreText === void 0 ? DEFAULT_SEE_MORE : _ref$seeMoreText,
    _ref$seeLessText = _ref.seeLessText,
    seeLessText = _ref$seeLessText === void 0 ? DEFAULT_SEE_LESS : _ref$seeLessText;
  return content === currentContent ? seeLessText : seeMoreText;
}